<template>
  <page-list
    :list="list"
    :columns="columns"
    :single-actions="singleActions" />
</template>

<script>
import * as R from 'ramda'
import ColumnsMixin from '../mixins/columns'
import SingleActionsMixin from '../mixins/singleActions'
import WindowsMixin from '@/mixins/windows'
import ListMixin from '@/mixins/list'

export default {
  name: 'AccountedBillList',
  mixins: [WindowsMixin, ListMixin, ColumnsMixin, SingleActionsMixin],
  props: {
    id: String,
    getParams: {
      type: [Function, Object],
    },
    cloudEnv: String,
  },
  data () {
    return {
      list: this.$list.createList(this, {
        id: this.id,
        resource: 'billing_bills',
        getParams: this.getParam,
      }),
    }
  },
  watch: {
    cloudEnv () {
      this.list.fetchData()
    },
  },
  created () {
    this.list.fetchData()
  },
  methods: {
    getParam () {
      const ret = { ...(R.is(Function, this.getParams) ? this.getParams() : this.getParams) }
      if (this.cloudEnv === 'paid') {
        ret.paid = true
      } else if (this.cloudEnv === 'due') {
        ret.due = true
      }
      return ret
    },
    handleOpenSidepage (row) {
      this.sidePageTriggerHandle(this, 'PendingPaymentSidePage', {
        id: row.id,
        resource: 'billing_bills',
        getParams: this.getParam,
        currentTab: 'bill-order-list',
      }, {
        list: this.list,
      })
    },
  },
}
</script>
